























import { Component } from 'vue-property-decorator';
import { LanguageJson } from '../json';
import FormBase from '@/base/EntityForm';
import store from '../store';
import { UserPermission } from '@/modules/user';

@Component<Form>({
  beforeRouteEnter(to, from, next): void
  {
    next(vm => vm.handleBeforeRouteEnter(to, from, next));
  },
  beforeRouteLeave(to, from, next): void
  {
    this.handleBeforeRouteLeave(to, from, next);
  },
})
export default class Form extends FormBase<LanguageJson, typeof store>
{
  protected hasWritePermission(): boolean {
    return this.hasPermission(UserPermission.LANGUAGE_WRITE);
  }

  protected readonly store = store;

  protected readonly closeRoute = {
    name: 'language',
  };
}
